// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n7zs","content":"styles_content__1q038","row":"styles_row__xPdw2","footer":"styles_footer__2d8F9","phraseLength":"styles_phraseLength__126p6"};